<template>
  <v-container class="pr-0 pl-0">
    <v-container class="pt-0 pl-6 pr-6">
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <v-switch
            v-model="enabled"
            :loading="firstLoading"
            :class="{'disable-events': !savingEnable}"
            @change="saveDisabled=false;"
            :label="$t('Enabled')"
            dense
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" class="text-right hidden-sm-and-down">
          <v-btn
            class="mr-4"
            color="grey darken-1"
            :loading="reloadLoading"
            v-if="savingEnable"
            @click="reload"
            outlined
            tile
          >
            <v-icon left>mdi-autorenew</v-icon>{{ $t("reload") }}
          </v-btn>
          <v-btn
            color="primaryLigth"
            :loading="saveLoading"
            :disabled="saveDisabled"
            v-if="savingEnable"
            @click="save"
            outlined
            tile
          >
            <v-icon left>mdi-content-save-outline</v-icon>{{ $t("save") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" md="6" class="text-right">
          <v-btn color="primaryLigth" @click="addBucketModal" v-if="savingEnable" outlined tile>
            <v-icon left>mdi-plus</v-icon>{{ $t("add bucket") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      :headers="bucketHeader"
      :items="buckets"
      :items-per-page="5"
      @click:row="updateBucketModal"
      class="mb-4"
    ></v-data-table>
    <v-container class="text-right hidden-md-and-up pl-6 pr-6 mb-6">
      <v-btn
        class="mr-4"
        color="grey darken-1"
        :loading="reloadLoading"
        @click="reload"
        outlined
        tile
      >
        <v-icon left>mdi-autorenew</v-icon>{{ $t("reload") }}
      </v-btn>
      <v-btn
        color="primaryLigth"
        :loading="saveLoading"
        :disabled="saveDisabled"
        @click="save"
        outlined
        tile
      >
        <v-icon left>mdi-content-save-outline</v-icon>{{ $t("save") }}
      </v-btn>
    </v-container>

    <PrinterBucketModal
      ref="printerBucketModal"
      @new="addBucket"
      @update="updateBucket"
      @remove="removeBucket"
    ></PrinterBucketModal>
  </v-container>
</template>

<script>
import axios from "axios";
import PrinterBucketModal from "./PrinterBucketModal";
import EventBus from "../../event-bus";

export default {
  components: {
    PrinterBucketModal,
  },
  data: () => ({
    firstLoading: true,
    saveLoading: false,
    saveDisabled: true,
    reloadLoading: false,
    enabled: null,
    printerCache: null,
    defaultSize: "A4",
    defaultSizeItems: [],
    bucketHeader: [
      { text: "Print SCP AE-Title", value: "aeTitle" },
      { text: "Equipments AE-Titles", value: "equipmentsText" },
      { text: "Paper Size", value: "paperSize" },
      { text: "Color", value: "colorPrinting" },
    ],
    buckets: [],
    counter: 0,
    savingEnable: false,
  }),
  mounted() {
    // Permissions
    let configuration = this.$store.getters.resources.configuration;
    
    if (configuration.print_server.update) {
      this.savingEnable = true;
    }

    // Paper Sizes (remove client opt)
    let defaultSizeItems = [...this.$printServer.paperSize];
    defaultSizeItems.forEach(function(item, index, object) {
      if (item.value === 'Client') {
        object.splice(index, 1);
      }
    });

    this.defaultSizeItems = defaultSizeItems;

    this.loadData();
  },
  methods: {
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    loadData() {
      axios({
        url: "/api/v1/config/printServer",
        method: "GET",
      })
        .then((response) => {
          this.enabled = response.data.printServer.enabled;
          this.printerCache = response.data.printServer.printerCache;
          this.defaultSize = response.data.printServer.defaultSize;
          // add id
          var buckets = response.data.printServer.buckets;
          var counter = 0;
          buckets.forEach(function (printer) {
            printer.id = counter++;
            printer.equipmentsText = printer.equipments.join(', ');
          });
          this.buckets = buckets;
          this.counter = counter;
          // stop loadings
          this.reloadLoading = false;
          this.firstLoading = false;
          this.saveDisabled = true;
        })
        .catch((error) => {
          this.reloadLoading = false;
          this.firstLoading = false;
          this.sendError(error);
        });
    },
    addBucketModal() {
      this.$refs.printerBucketModal.show(null, this.counter);
      this.counter = this.counter + 1;
    },
    updateBucketModal(data) {
      this.$refs.printerBucketModal.show(data);
    },
    addBucket(data) {
      this.saveDisabled = false;
      this.buckets.push(data);
    },
    updateBucket(data) {
      this.saveDisabled = false;
      this.buckets.forEach(function (printer) {
        if (printer.id == data.id) {
          printer.aeTitle = data.aeTitle;
          printer.equipments = data.equipments;
          printer.equipmentsText = data.equipments.join(', ');
          printer.paperSize = data.paperSize;
          printer.colorPrinting = data.colorPrinting;
          printer.border = data.border;
          printer.emptyImage = data.emptyImage;
          printer.brighten = data.brighten;
          printer.contrast = data.contrast;
          printer.destination = data.destination;
        }
      });
    },
    removeBucket(data) {
      this.saveDisabled = false;
      this.buckets = this.buckets.filter(function (el) {
        return el.id != data.id;
      });
    },
    reload() {
      this.reloadLoading = true;
      this.loadData();
    },
    save() {
      this.saveLoading = true;

      // send configuration
      axios({
        url: "/api/v1/config/printServer",
        method: "PUT",
        data: {
          enabled: this.enabled,
          printerCache: this.printerCache,
          defaultSize: this.defaultSize,
          buckets: this.buckets,
        },
      })
        .then((response) => {
          this.saveLoading = false;
          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.sendError(response.data.error);
          } else {
            this.saveDisabled = true;
          }
        })
        .catch((error) => {
          this.saveLoading = false;
          this.sendError(error);
        });
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
.disable-events {
  pointer-events: none;
}
</style>